import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { clientLogin, updateLoginState,redirectToMicrosoft } from '../actions/loginactions'
import * as securityActions from '../../../actions/securityactions';
import * as appUtilityFunctions from '../../../infrastructure/apputilityfunctions';


export default function LogIn() {
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const state = useSelector(state => state.loginReducer);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let pageMenuId = appUtilityFunctions.getUrlParameter('pageId');
    useEffect(() => {
        dispatch(securityActions.checkAccess({ pageMenuId })).then(resp => {
            if (resp) {
                redirectIfRequired();
            }
        });
    }, []);

    function redirectIfRequired() {
        if (pageMenuId == null || pageMenuId == '') {
            navigate('/dashboard');
        } else {
            dispatch(securityActions.redirectToPage(pageMenuId));
        }
    }


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        dispatch(updateLoginState({ name, value }));
    }
    const onSubmit = async () => {
        if (await dispatch(clientLogin(pageMenuId))) {
            navigate('/dashboard');
        }
    }
    const recoverPassword = () => {
        navigate('/recoverpassword');
    }
    const outlookLogin = async () => {
        await dispatch(redirectToMicrosoft(pageMenuId));        
    }
    const currentYear = new Date().getFullYear();
    return (
        <>
        <div className="auth-fluid">
            {/*-- auth-fluid-form-box-->*/}
            <div className="auth-fluid-form-box">
                <div className="align-items-center d-flex h-100">
                    <div className="card-body">

                        <div className="auth-brand text-center text-lg-start">
                            <a href="index.html" className="logo-dark">
                                <span><img src="content/theme/assets/images/asniclogo.png" alt="" style={{ "height": 50 }} /></span>
                            </a>
                            <a href="index.html" className="logo-light">
                                <span><img src="content/theme/assets/images/asniclogo.png" alt="" style={{ "height": 18 }} /></span>
                            </a>
                        </div>

                        <h4 className="mt-0">Sign In</h4>
                        <p className="text-muted mb-4">Enter your email address and password to access account.</p>

                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="mb-3">
                                <label for="emailaddress" className="form-label">User name</label>
                                <input className={errors.userName ? 'form-control is-invalid' : 'form-control'}
                                    type="text" id="emailaddress" required=""
                                    placeholder="Enter your user name"
                                    name='userName'
                                    {...register("userName", { required: true, onChange:(e) => handleInputChange(e)})}
                                    value={state.userName}
                                />
                            </div>
                            <div className="mb-3">
                                <a href type='button' onClick={() => recoverPassword()} className="text-muted float-end"><small>Reset / Forgot your password?</small></a>
                                <label for="password" className="form-label">Password</label>
                                <input name='password'
                                    className={errors.password ? 'form-control is-invalid' : 'form-control'}
                                    type="password" required="" id="password" placeholder="Enter your password"
                                    {...register("password", { required: true, onChange:(e) => handleInputChange(e) })}
                                    value={state.password}
                                    
                                />
                                <div className="d-grid mb-0 text-center">
                                    <span style={{ color: "red" }}>  {state.loginMessage && state.loginMessage}</span>
                                </div>
                            </div>
                            
                            <div className="d-grid mb-0 text-center">
                                <button className="btn btn-primary" type="submit" >
                                Log In </button>
                            </div>


                            <div className="text-center mt-4">
                                <p className="text-muted font-16">Sign in with</p>
                                <ul className="social-list list-inline mt-3">
                                    <div className="d-grid mb-0 text-center">
                                        <button className="btn btn-success" onClick={() => outlookLogin()} ><i className="mdi mdi-microsoft"></i> Outlook Log In </button>
                                    </div>

                                </ul>
                            </div>
                        </form>
                        <footer className="footer footer-alt">
                            <p className="text-muted">Copyright @ Al Sagr Insurance {currentYear}</p>
                        </footer>
                        
                    </div>
                </div>
            </div>
            {/*-- end auth-fluid-form-box-->*/}``
            
        </div>
        
        </>
    )
}
